import { Modal } from 'react-bootstrap';
import { usePopupContext } from './PopupContextProvider';
import useMobile from 'hooks/useMobile';
import { Button, Image } from 'components/common';

const PostAddToCartPopup = () => {
  const {
    showPostAddToCartPopup,
    dismissPostAddToCartPopup,
  } = usePopupContext();

  const isMobile = useMobile();

  return (
    <Modal
      backdrop="static"
      show={showPostAddToCartPopup}
      centered
      onHide={dismissPostAddToCartPopup}
      size="lg"
      className="tw-p-0"
    >
      <Modal.Body className="tw-p-0">
        <div className="md:tw-flex tw-relative tw-w-full">
          <div
            className={
              isMobile
                ? 'tw-hidden'
                : 'tw-w-full md:tw-w-[40%] md:tw-flex-shrink-0 tw-h-[36rem] md:tw-h-auto tw-relative'
            }
          >
            <Image
              src="/assets/images/popups/post-add-to-cart.png"
              alt="Post Add To Cart"
              width={1500}
              height={2121}
              priority
              layout={isMobile ? 'fill' : 'responsive'}
              className="tw-w-full tw-h-full tw-object-cover tw-object-[50%_15%] md:tw-object-center"
            />
          </div>
          <div className="tw-w-full md:tw-flex-1 tw-px-8 tw-py-8 md:tw-py-28 tw-flex tw-flex-col tw-justify-center tw-items-center tw-relative">
            <div className="tw-flex tw-flex-col tw-space-y-8 tw-max-w-2xl tw-w-full">
              <div className="tw-flex tw-flex-col tw-space-y-4">
                <h1 className="tw-font-therebrat tw-text-[5.5rem] md:tw-text-[6.75rem] tw-font-medium tw-tracking-wide tw-mb-0 tw-text-center tw-leading-none">
                  Great Choice
                </h1>
                <h2 className="tw-text-center tw-text-4xl tw-font-extrabold tw-mb-0 tw-leading-none">
                  💪 Did You Know?
                </h2>
              </div>
              <div className="tw-flex tw-justify-center tw-items-start ">
                <div className="tw-hidden md:tw-flex tw-gap-x-14">
                  <ul className="tw-list-disc tw-leading-tight tw-text-2xl tw-mb-0">
                    <li>Cooked fresh in-house</li>
                    <li>No added preservatives</li>
                    <li>Halal-Certified</li>
                  </ul>
                  <ul className="tw-list-disc tw-leading-tight tw-text-2xl tw-mb-0">
                    <li>Islandwide delivery</li>
                    <li>Store frozen for 7 days</li>
                    <li>Easily re-heat in 3-5 mins</li>
                  </ul>
                </div>
                <div className="tw-flex md:tw-hidden">
                  <ul className="tw-list-disc tw-leading-tight tw-text-2xl tw-mb-0">
                    <li>Cooked fresh in-house</li>
                    <li>No added preservatives</li>
                    <li>Halal-Certified</li>
                    <li>Islandwide delivery</li>
                    <li>Store frozen for 7 days</li>
                    <li>Easily re-heat in 3-5 mins</li>
                  </ul>
                </div>
              </div>
              <div className="tw-flex tw-justify-center tw-gap-4">
                <Button
                  className="tw-uppercase tw-text-[1.1rem] md:tw-text-[1.25rem] tw-whitespace-nowrap"
                  onClick={dismissPostAddToCartPopup}
                >
                  <>Continue Shopping</>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <button
          title="Close (Esc)"
          type="button"
          className={
            isMobile
              ? 'tw-hidden'
              : 'mfp-close tw-top-2 tw-right-2 tw-text-[1.5rem]'
          }
          onClick={dismissPostAddToCartPopup}
        >
          <span>×</span>
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default PostAddToCartPopup;
